import { useEffect, useRef } from 'react';
import { apiGet } from './api-client';

export interface OurContact {
  contactName: string;
  contactRole: string;
  contactEmail: string;
  contactPhone: string;
}

export function useOurContact(enabled: boolean, apply: (contact: OurContact) => void) {
  const started = useRef(false);
  const applyRef = useRef(apply);
  applyRef.current = apply;
  useEffect(() => {
    if (!enabled || started.current) return;
    started.current = true;
    let live = true;
    void apiGet<{ settings?: Partial<OurContact> }>('/api/settings').then((data) => {
      if (!live) return;
      const settings = data.settings || {};
      applyRef.current({
        contactName: String(settings.contactName || ''),
        contactRole: String(settings.contactRole || ''),
        contactEmail: String(settings.contactEmail || ''),
        contactPhone: String(settings.contactPhone || ''),
      });
    }).catch(() => undefined);
    return () => { live = false; };
  }, [enabled]);
}
